import {
  RenterAccessmentBadge,
  RenterAssessmentParams,
  RenterAssessmentItem,
} from '../../interfaces/renter-profile-assessment.interface';

export const identityVerificationAssessmentBadges: {
  verified: RenterAccessmentBadge;
  pending: RenterAccessmentBadge;
  declined: RenterAccessmentBadge;
} = {
  verified: { title: 'ID verified', badgeColor: 'green' },
  pending: { title: 'ID verification pending', badgeColor: 'yellow' },
  declined: { title: 'ID verification declined', badgeColor: 'red' },
};

/**
 * Verification is renter-scoped, so "ID verified" shows up even on a lead who verified for another
 * owner's property — that is the point: one pass covers every property. status null means the
 * renter was never asked to verify (no badge, N/A); everything between (in progress, in review, an
 * expired or abandoned attempt, a stale approval) reads as pending, because the next conversation
 * hands them a fresh link.
 */
export function getIdentityVerificationAssessment(assessmentParams: RenterAssessmentParams): RenterAssessmentItem {
  const identityVerification = assessmentParams.renter?.identityVerification;

  if (identityVerification?.isVerified) {
    return { uiRepresentation: 'Verified', badge: identityVerificationAssessmentBadges.verified };
  }

  if (!identityVerification?.status) {
    return { uiRepresentation: 'N/A', badge: null };
  }

  if (identityVerification.status === 'Declined') {
    return { uiRepresentation: 'Declined', badge: identityVerificationAssessmentBadges.declined };
  }

  return { uiRepresentation: 'Pending', badge: identityVerificationAssessmentBadges.pending };
}
